import { Action, compose, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import axios from 'axios';

import { AssociationInterface } from '../../types';
import { associationsLoadingSelector, associationsSelector, moreAssociationsLoadingSelector, randomSelector } from '../selectores';

import { RootState } from '../store';

const associationsSlice = createSlice({
	name: 'associations',

	initialState: {
		associations: null as AssociationInterface[] | null,
		moreAssociationsLoading: false,
		associationsError: false,
		noMoreAssociations: false,
		random: Math.random() * 100
	},

	reducers: {
		getAssociationsFulfilled: (state, action: PayloadAction<AssociationInterface[]>) => {
			state.associations = action.payload;
		},

		setMoreAssociationsLoading: (state, action: PayloadAction<boolean>) => {
			state.moreAssociationsLoading = action.payload;
		},

		getMoreAssociationsFulfilled: (state, action: PayloadAction<AssociationInterface[]>) => {
			state.associations?.push(...action.payload);
		},

		setAssociationsError: state => {
			state.associationsError = true;
		},

		setNoMoreAssociations: state => {
			state.noMoreAssociations = true;
		},
	}
});

export const { getAssociationsFulfilled, setMoreAssociationsLoading, getMoreAssociationsFulfilled, setAssociationsError, setNoMoreAssociations } = associationsSlice.actions;

export const getAssociations = (): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch, getState) => {
	try {
		const state = getState();
		const random = randomSelector(state);
		const { data: associations } = await axios.get<AssociationInterface[]>(`/api/association?random=${random}`);
		compose(dispatch, getAssociationsFulfilled)(associations);
	} catch (error) {
		console.error(error);
		compose(dispatch, setAssociationsError)();
	}
}

export const getMoreAssociations = (): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch, getState) => {
	try {
		const state = getState();
		const loading = associationsLoadingSelector(state);
		const moreLoading = moreAssociationsLoadingSelector(state);
		if (loading || moreLoading) return;

		compose(dispatch, setMoreAssociationsLoading)(true);

		const associationsLength = associationsSelector(state)?.length || 0;
		const random = randomSelector(state);

		const { data: associations } = await axios.get<AssociationInterface[]>(`/api/association?skip=${associationsLength}&random=${random}`);
		compose(dispatch, getMoreAssociationsFulfilled)(associations);
		compose(dispatch, setMoreAssociationsLoading)(false);
		if (associations.length === 0) compose(dispatch, setNoMoreAssociations)();
	} catch (error) {
		console.error(error);
		compose(dispatch, setMoreAssociationsLoading)(false);
	}
}

export const associationsReducer = associationsSlice.reducer;